const RESTRICTED_TYPES = ['private', 'students only', 'restricted'];

export default RESTRICTED_TYPES;